export function translate (term, lang) {
    if(!lang) lang = window.lang || "en";

    if(!term) return "";

    var foundTerm = window.vocab[term];
    return foundTerm ? foundTerm[lang] || term : term
}